<!-- Post Type Dropdown Component -->
<div class="cms-post-type-dropdown">
  
  <!-- Loading State -->
  @if (loading()) {
    <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 dark:border-blue-400"></div>
      <span>Loading post types...</span>
    </div>
  }

  <!-- Error State -->
  @else if (error()) {
    <div class="text-sm text-red-600 dark:text-red-400">
      {{ error() }}
    </div>
  }

  <!-- Post Type Selection UI -->
  @else {
    
    <!-- Search Input (conditional based on threshold) -->
    @if (shouldShowSearch()) {
      <div class="relative mb-3">
        <input
          type="text"
          [value]="searchTerm()"
          (input)="onSearchChange($any($event.target).value)"
          placeholder="Search post types..."
          [disabled]="disabled()"
          class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg 
                 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100
                 placeholder-gray-400 dark:placeholder-gray-500
                 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent
                 disabled:opacity-50 disabled:cursor-not-allowed
                 transition-all"
          aria-label="Search post types">
        <svg class="absolute right-3 top-2.5 h-4 w-4 text-gray-400 dark:text-gray-500 pointer-events-none" 
             fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    }

    <!-- Post Type Dropdown -->
    <div class="relative">
      <select
        [value]="selectedPostTypeId() || ''"
        (change)="onSelectionChange($any($event.target).value || null)"
        [disabled]="disabled()"
        class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg 
               bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100
               focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent
               disabled:opacity-50 disabled:cursor-not-allowed
               transition-all cursor-pointer"
        aria-label="Select post type">
        <option value="">{{ placeholder() }}</option>
        @for (postType of filteredPostTypes(); track postType._id) {
          <option [value]="postType._id">
            {{ postType.typeName }}
          </option>
        }
      </select>

      <!-- Empty State (when search returns no results) -->
      @if (filteredPostTypes().length === 0 && searchTerm()) {
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
          No post types found matching "{{ searchTerm() }}"
        </p>
      }

      <!-- No Post Types Available -->
      @if (postTypes().length === 0 && !loading()) {
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
          No post types available
        </p>
      }
    </div>

    <!-- Selected Post Type Display (optional visual feedback) -->
    @if (selectedPostTypeId() && selectedPostTypeName()) {
      <p class="text-xs text-gray-600 dark:text-gray-400 mt-2">
        Selected: <span class="font-medium">{{ selectedPostTypeName() }}</span>
      </p>
    }
  }
</div>
